/**
 * 神策 Transport 拦截器
 *
 * 拦截 XHR / fetch，对发往神策的请求：
 * 1. 重新打包 body — base64 → JSON 外壳 + country 注入
 * 2. HMAC-SHA256 签名头注入
 * 3. Content-Type 纠正
 * 4. MPA keepalive 防页面跳转丢数据
 *
 * 输出格式: {"data":"<base64>","zip":0,"terminal":"web","debug":false,"country":"XX","version":"V2"}
 */

(function () {
  var COUNTRY_MAP = {
    us: 'US', jp: 'JP', kr: 'KR', uk: 'GB',
    de: 'DE', 'de-en': 'DE',
    fr: 'FR', 'fr-en': 'FR',
    it: 'IT', 'it-en': 'IT',
    'cz-en': 'CZ', 'nl-en': 'NL'
  };
  var HMAC_SECRET = 'xreal@overseas';
  var HMAC_MSG_PREFIX = 'x_real_oversea';

  var _enc = new TextEncoder();
  var _hmacKey = null;

  function getHmacKey() {
    if (_hmacKey) return _hmacKey;
    return (_hmacKey = crypto.subtle.importKey('raw', _enc.encode(HMAC_SECRET), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']));
  }

  function resolveCountry() {
    var segment = window.location.hostname.split('.')[0] || '';
    return COUNTRY_MAP[segment] || 'US';
  }

  function toBase64(str) {
    return btoa(unescape(encodeURIComponent(str)));
  }

  function packBody(body, country) {
    var raw = body;
    if (raw.indexOf('data_list=') === 0) raw = raw.slice(10);
    else if (raw.indexOf('data=') === 0) raw = raw.slice(5);
    var json = atob(decodeURIComponent(raw.split('&ext=')[0]));
    return JSON.stringify({
      data: toBase64('[' + json + ']'),
      zip: 0,
      terminal: 'web',
      debug: false,
      country: country,
      version: 'V2'
    });
  }

  async function getAuthHeaders() {
    var tm = String(Date.now());
    var key = await getHmacKey();
    var sig = await crypto.subtle.sign('HMAC', key, _enc.encode(HMAC_MSG_PREFIX + tm));
    var sign = Array.from(new Uint8Array(sig))
      .map(function (b) { return b.toString(16).padStart(2, '0'); })
      .join('');
    return { tm: tm, sign: sign };
  }

  function shouldIntercept(url, sensorHost, body) {
    return url.indexOf(sensorHost) > -1 && typeof body === 'string' && body.indexOf('data') === 0;
  }

  window.hookTransport = function (serverUrl) {
    var sensorHost;
    try { sensorHost = new URL(serverUrl).hostname; } catch (e) { return; }
    var country = resolveCountry();

    // Hook XHR — use fetch + keepalive for MPA page navigation safety
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    var _setHeader = XMLHttpRequest.prototype.setRequestHeader;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__surl = typeof url === 'string' ? url : url.href;
      return _open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.setRequestHeader = function (name, value) {
      if (this.__surl && this.__surl.indexOf(sensorHost) > -1 && name.toLowerCase() === 'content-type') return;
      return _setHeader.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      if (!shouldIntercept(this.__surl, sensorHost, body)) return _send.call(this, body);
      var self = this;
      try { doSend(packBody(body, country)); } catch (e) { _send.call(this, body); }

      function doSend(packed) {
        getAuthHeaders()
          .then(function (auth) {
            fetch(self.__surl, {
              method: 'POST',
              body: packed,
              keepalive: true,
              headers: { 'Content-Type': 'application/json; charset=UTF-8', 'tm': auth.tm, 'sign': auth.sign }
            }).catch(function () {});
          })
          .catch(function () {
            fetch(self.__surl, {
              method: 'POST',
              body: packed,
              keepalive: true,
              headers: { 'Content-Type': 'application/json; charset=UTF-8' }
            }).catch(function () {});
          });
      }
    };

    // Hook fetch
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
      if (!shouldIntercept(url, sensorHost, init && init.body)) {
        return _fetch.apply(window, arguments);
      }
      var packed = packBody(init.body, country);
      return getAuthHeaders()
        .then(function (auth) {
          return _fetch.call(window, input, Object.assign({}, init, {
            body: packed,
            keepalive: true,
            headers: Object.assign({}, init.headers, { tm: auth.tm, sign: auth.sign })
          }));
        })
        .catch(function () {
          return _fetch.call(window, input, Object.assign({}, init, { body: packed, keepalive: true }));
        });
    };
  };
})();
